import { Box, debounce, Grid, TextField } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import { useStyles } from "./style";
import { useFormik } from "formik";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import CommonButton from "src/components/CommonButton/CommonButton";
import { object, string } from "yup";
import {
  currentContainerNo,
  currentIndexNumber,
  currentSelectedPaymentId,
  currentVirNumber,
} from "src/app-redux/commercial/commercialSlice";
import { getPaymentDetailsById } from "src/app-redux/commercial/actions/commercialActions";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import MultiSelect2 from "src/components/molecules/MultiSelect2";

export interface IDrawerAddPaymentProps {}

export default function DrawerGatePass(props: IDrawerAddPaymentProps) {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  //Redux
  const selectedPaymentId = useAppSelector(currentSelectedPaymentId);
  const selectedVirNumber = useAppSelector(currentVirNumber);
  const selectedContainerNumber = useAppSelector(currentContainerNo);
  const selectedIndexNumber = useAppSelector(currentIndexNumber);

  const [vehicleRegNumberArr, setvehicleRegNumberArr] = React.useState<any[]>([]);
  const [vehicleNumberLength, setVehicleNumberLength] = React.useState<number>(0);
  const [chassisOptions, setChassisOptions] = useState<any[]>([]);
  const [selectedChassis, setSelectedChassis] = useState<any[]>([]);
  const multiselectRef = useRef(null);
  const multiSelectKey = "chassis-selector";
  const [loader, setLoader] = useState(false);

  const validationSchema = object({
    vehicleId: string().required("This field is required"),
  });

  const formik = useFormik<any>({
    enableReinitialize: true,
    initialValues: {
      gatePassPaymentId: selectedPaymentId,
      vehicleId: "",
      containerNumber: selectedContainerNumber,
      virNumber: selectedVirNumber,
      indexNumber: selectedIndexNumber,
      // virNumber: "", // needed for fetch
      //containerNumberIndex: "", // needed for fetch
      containerIndexes: "", // comma-separated container index values
      chassisNumbers: "", // holds the selected chassis as comma-separated string
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any, actions) => {
      const res: any = await fetchWrapper.post("update-vehicle-for-gate-pass-invoice", {
        paymentId: selectedPaymentId,
        vehicleId: values.vehicleId,
        containerNumber: selectedContainerNumber,
        virNumber: selectedVirNumber,
        indexNumber: selectedIndexNumber,
        chassisNumbers: values.chassisNumbers,
      });
      dispatch(getPaymentDetailsById(selectedPaymentId));
      if (res.payload) {
        actions.setSubmitting(false);
        formik.resetForm();
        formik.setValues(formik.initialValues);
        return;
      }
    },
  });
  const fetchChassisByIndex = async () => {
    try {
      setLoader(true);
      const { virNumber, containerNumber, indexNumber } = formik.values;
      //const firstContainerIndex = Number(indexNumber?.split(",")[0]);
      const response = await fetchWrapper.get(
        `/get-all-containers-index_chasis_numbers/${containerNumber}?virNo=${virNumber}&indexNumber=${indexNumber}`
      );

      if (response.isSuccess) {
        setChassisOptions(response.value.chasisNumbers || []);
      } else {
        dispatch(
          addNotificationAction({
            message: "Failed to fetch chassis numbers",
            options: { variant: "error" },
          })
        );
      }
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    const { virNumber, containerNumber, indexNumber } = formik.values;
    if (virNumber && containerNumber && indexNumber) {
      fetchChassisByIndex();
    }
  }, []);

  const getVehicleByRegistrationNo = async (queryString: string) => {
    let results: any = [];
    results = await fetchWrapper.get(
      `search-vehicles-by-vehicle-registration-number/${queryString}`
    );
    if (results.isSuccess) {
      setvehicleRegNumberArr(results.value);
    }
    return;
  };
  return (
    <div className={classes.drawerDetails}>
      {/* Drawer Status Item  */}

      <Grid container spacing={2} className="topContainer" style={{ marginTop: "5px" }}>
        <Grid container direction="row" className="itemRow" spacing={2}>
          <Grid item xs={12} md={12} style={{ height: "55px" }}>
            <CommonAutoCompleteField
              cssClassName="customTextField"
              label="Vehicle Number"
              placeholder="Enter Vehicle Number"
              name="vehicleId"
              optionsType={vehicleRegNumberArr}
              getOptionLabel={(option) => option.registrationNumber || ""}
              required
              value={
                vehicleRegNumberArr.find((st: any) => st.vehicleId == formik.values.vehicleId) ||
                null
              }
              onChange={(option: any) => {
                formik.setFieldValue("vehicleId", option.vehicleId);
              }}
              onKeyUp={(e: any) => {
                setVehicleNumberLength(e.target.value.length);
                if (e.target.value.length == 2 && vehicleNumberLength < 2) {
                  getVehicleByRegistrationNo(e.target.value);
                  return;
                }
              }}
              // onKeyDownCapture={(e: any) => {
              //   if (/[^A-Za-z0-9\d]/.test(e.key)) e.preventDefault();
              //   else handleChange(e);
              // }}
              error={formik.touched.vehicleId && Boolean(formik.errors.vehicleId)}
              helperText={formik.touched.vehicleId && formik.errors.vehicleId}
            />
          </Grid>
          {chassisOptions.length > 0 && (
            <Grid item xs={12} md={12} style={{ marginTop: "8px" }}>
              <TextField
                className="customTextField"
                size="small"
                fullWidth
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                inputProps={{ readOnly: true }}
                label="Chassis Numbers"
                name="chassisNumbers"
                value={formik.values.chassisNumbers || ""}
                error={formik.touched.chassisNumbers && Boolean(formik.errors.chassisNumbers)}
                helperText={formik.touched.chassisNumbers && formik.errors.chassisNumbers}
              />

              <Box
                className={classes.multiselectConfigFileCompression}
                style={{
                  bottom:
                    formik.touched.chassisNumbers && Boolean(formik.errors.chassisNumbers)
                      ? "55px"
                      : "35px",
                }}
              >
                <MultiSelect2
                  allValues={chassisOptions}
                  selctedItems={selectedChassis}
                  displayValue="chasisNumber"
                  placeholder={loader ? "Loading..." : "Select Chassis Numbers"}
                  onSelect={(selectedList: any[], selectedItem: any) => {
                    setSelectedChassis(selectedList);
                    formik.setFieldValue(
                      "chassisNumbers",
                      selectedList.map((item) => item.chasisNumber).join(", ")
                    );
                  }}
                  onRemove={(selectedList: any[], removedItem: any) => {
                    setSelectedChassis(selectedList);
                    formik.setFieldValue(
                      "chassisNumbers",
                      selectedList.map((item) => item.chasisNumber).join(", ")
                    );
                  }}
                  ref={multiselectRef}
                  key={multiSelectKey}
                />
              </Box>
            </Grid>
          )}

          <Grid container item xs={12} md={12}>
            <Grid item xs={12} md={9}>
              <Box textAlign="left" mt={1}>
                <CommonButton
                  cssClass="customSubmitBtn"
                  onClick={() => {
                    formik.resetForm();
                    formik.setValues(formik.initialValues);
                  }}
                >
                  Reset
                </CommonButton>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  // disable={}
                  onClick={() => {
                    formik.submitForm();
                  }}
                >
                  Save
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
